import { render } from "./DefColorsSmall.vue?vue&type=template&id=f069d01a&scoped=true"
import script from "./DefColorsSmall.vue?vue&type=script&lang=js"
export * from "./DefColorsSmall.vue?vue&type=script&lang=js"

import "./DefColorsSmall.vue?vue&type=style&index=0&id=f069d01a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f069d01a"]])

export default __exports__